/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../../api/index';
import * as core from '../../../../../core';
import * as serializers from '../../../../index';

export const PresentationImportRequest: core.serialization.Schema<
    serializers.PresentationImportRequest.Raw,
    Omit<Truvity.PresentationImportRequest, 'blobId' | 'idempotencyKey'>
> = core.serialization.object({
    annotations: core.serialization.record(core.serialization.string(), core.serialization.string()).optional(),
    labels: core.serialization.record(core.serialization.string(), core.serialization.string()).optional(),
});

export declare namespace PresentationImportRequest {
    export interface Raw {
        annotations?: Record<string, string> | null;
        labels?: Record<string, string> | null;
    }
}
